import { render } from "./RefreshBtn.vue?vue&type=template&id=b6edb44c&scoped=true"
const script = {}

import "./RefreshBtn.vue?vue&type=style&index=0&id=b6edb44c&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6edb44c"]])

export default __exports__